import React from "react";

const Form = React.lazy(() => import("./cms/areas/form/containers/FormLayout/FormLayout"));
const FormPost = React.lazy(() => import("./cms/areas/form/containers/PostFormLayout/PostFormLayout"));
const PageEdit = React.lazy(() => import("./cms/areas/page/container/Editor/Layout/PageEditorLayout"));
const PageView = React.lazy(() => import("./cms/areas/page/container/View/Layout/PageViewLayout"));
/* const OrganizationSettings = React.lazy(() => import("./organization/OrganizationSettings/OrganizationSettings")); */
/* const SystemLabelHandler = React.lazy(() => import("./system/SystemLabelHandler/SystemLabelHandler")); */
const Template = React.lazy(() => import("./cms/areas/template/containers/TemplateLayout/TemplateLayout"));
const ArticlesEditor = React.lazy(() => import("./cms/areas/page/plugins/article/containers/ArticleEditor/ArticleEditor"));
const DibsPayment = React.lazy(() => import("./payments/CardPayment/Dibs/Dibs"));
const EmailEditor = React.lazy(() => import("./cms/areas/email/containers/EmailEditor/EmailEditor"));
const MeetingEditor = React.lazy(() => import("./cms/areas/meeting/container/EditorLayout/MeetingEditorLayout"));
const Layout = React.lazy(() => import("./cms_2.0/Layout"));
// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config


const routes = [
  { path: "/cms/email/:id", name: "Email Editor", component: EmailEditor, labelGroup: "Email.Edit" },
  { path: "/cms/form/:id", name: "Form", component: Form, labelGroup: "Form.Edit" },
/*   { path: "/organization/settings", name: "Organization Settings", component: OrganizationSettings, labelGroup: "Account.Organization" }, */
/*   { path: "/system/labelhandler", name: "Label Handler", component: SystemLabelHandler, labelGroup: "System.LabelHandler" }, */
  { path: "/cms/template", name: "Template Editor", component: Template, labelGroup: "Template.Edit" },
  { path: "/p/:id", name: "Event Page", component: FormPost, labelGroup: "Page.Edit" },
  { path: "/register/:id", name: "Register Form", component: FormPost, labelGroup: "Form.Post" },
  { path: "/register/dibs/:id", name: "Dibs Payment", component: DibsPayment, labelGroup: "Dibs.Paywindow" },
  { path: "/survey/:id", name: "Register Survey", component: FormPost, labelGroup: "Form.Post" },
  { path: "/articles/edit", name: "Article Editor", component: ArticlesEditor, labelGroup: "Article.Edit" },
  { path: "/cms/page/:id", name: "Page Editor", component: PageEdit, labelGroup: "Page.Edit" },
  { path: "/page/:id", name: "Page View", component: PageView, labelGroup: "Page.Edit" },
  { path: "/web/:id", name: "Page View", component: Layout, labelGroup: "Page.Edit" },
  { path: "/register2/:id", name: "Page View", component: Layout, labelGroup: "Page.Edit" },
  /*    { path: '/cms/meeting/:id', name: 'Meeting Editor', component: MeetingEditor, labelGroup: "Meeting.Edit" }, */
];

export default routes;
